/** change customer Id and store to default on production */
import axios from 'axios';
import Swal from 'sweetalert2';
import dayjs from 'dayjs';
export default () => ({
  axios: axios,
  Swal: Swal,
  dayjs: dayjs,
  auth: {
    system_ready: false,
    access_token: null,
    refresh_token: null,
  },
  cdn: 'https://d26ail1whk9u0q.cloudfront.net/public/mycrokys',
  // cdn_root: 'https://d26ail1whk9u0q.cloudfront.net/public/',
  cdn_root: 'https://d26ail1whk9u0q.cloudfront.net/public/',
  prod_api: '/apps/api',
  api: process.env.NODE_ENV === 'development' ? '/apps/api' : '/apps/api',
  admin_domain: '660379.myshopify.com',
  environment: process.env.NODE_ENV,
  productVariants: ['DE', 'AT', 'CH', 'EU'],
  targetVariant: 'EU',
  // customerId: 7384378736970,
  customerId: document.querySelector('body').dataset.customerId || null,
  shopify: window.Shopify,
  store: 'mc',
  geo: {},
  varifyVariant: window.varifyVariant || null,
  pastboxes: [],
  money(value, formatted = false) {
    let finalValue = formatted ? Number(value) : Number(Number(value) / 100);
    return new Intl.NumberFormat(window.Shopify.country, {
      style: 'currency',
      currency: window.Shopify.currency.active,
    }).format(finalValue);
  },
  async geoLocation() {
    const data = await fetch(`/browsing_context_suggestions.json`);
    const response = await data.json();
    this.geo = response;
    let { detected_values } = response;
    let { country } = detected_values;
    let { handle } = country;
    if (this.productVariants.includes(handle.toUpperCase())) {
      this.targetVariant = handle.toUpperCase();
    }
  },
  async getPastboxes(subscription_type = '') {
    const data = await fetch(`${this.api}/settings/pastboxes?subscription_type=${subscription_type}&store=mc`);
    const response = await data.json();
    this.pastboxes = response;
  },
  emojiFlag(countryCode) {
    return String.fromCodePoint(...[...countryCode.toUpperCase()].map((x) => 0x1f1a5 + x.charCodeAt()));
  },
  showSideBar: false,
  showSideBarNew: false,
  async setCustomerId(cId) {
    this.customerId = await 5227287609440;
    // this.customerId = await 1412979163232;
    // this.customerId = cId;
  },
  async setInterceptor() {
    const token = this.auth.access_token;
    axios.interceptors.request.use(
      function (config) {
        // Do something before request is sent
        if (token) {
          config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
      },
      function (error) {
        // Do something with request error
        return Promise.reject(error);
      },
    );

    this.axios.interceptors.request.use(
      function (config) {
        // Do something before request is sent
        if (token) {
          config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
      },
      function (error) {
        // Do something with request error
        return Promise.reject(error);
      },
    );

    this.auth.system_ready = true;
  },
});
